













import TIcons from '@/types/TIcons';
import Vue from 'vue';
import InlineSVG from 'vue-inline-svg';

interface IBaubleComponent {
  imagePath: string;
}

export default Vue.extend({
  name: `Bauble`,
  components: { InlineSVG },
  data(): IBaubleComponent {
    return {
      imagePath: TIcons.christmasCalendar.baubleWithEyelet,
    };
  },
  props: {
    doorNumber: {
      required: true,
      type: Number,
    },
  },
  methods: {
    baubleSelected(): void {
      this.$emit(`click:bauble`, this.doorNumber);
    },
  },
});
